import React, { useContext } from 'react'
import { flowRight } from 'lodash'
import { graphql } from '@apollo/client/react/hoc'
import { fetchPolicy } from 'lib/apolloFetchPolicy'
import { withTranslationCustom } from 'lib/i18next'
import { VERTICAL, wrapVehicle } from 'lib/utils/store/vehicle'

import LoadingIndicator from 'components/LoadingIndicator'
import ErrorComponent from 'components/Errors/ErrorComponent'
import EventForm, { EVENT_FORM_MODE } from 'components/Events/EventForm/EventForm'
import { EventFormLogicContext } from 'components/Events/EventForm/EventFormLogic'
import InspectionEventFormReminderTrafiDialog from './InspectionEventFormReminderTrafiDialog'
import InspectionEventFormCreateEventTrafiDialog from './InspectionEventFormCreateEventTrafiDialog'
import StatusMessage from 'components/StatusMessage'

import getInspectionEventFormData from 'graphql/event/getInspectionEventFormData.gql'

import './inspection-event-form-reminder-trafi-dialog.pcss'

const InspectionEventForm = ({ t, data }) => {
    const { formMode, latestEventCreated } = useContext(EventFormLogicContext)

    const { loading, error, vehicle } = data

    if (error) return <ErrorComponent />
    if (loading) return <LoadingIndicator />

    const wrappedVehicle = wrapVehicle(vehicle)

    if (wrappedVehicle.getRegNumber() && vehicle.vertical !== VERTICAL.BOAT) {
        switch (formMode) {
        case EVENT_FORM_MODE.CREATE_REMINDER:
            return (
                <InspectionEventFormReminderTrafiDialog wrappedVehicle={wrappedVehicle}>
                    {() => (
                        <>
                            {latestEventCreated && (
                                <StatusMessage type="success">
                                    {t('events:messages.latestEventAdded')}
                                </StatusMessage>
                            )}
                            <EventForm />
                        </>
                    )}
                </InspectionEventFormReminderTrafiDialog>
            )
        case EVENT_FORM_MODE.CREATE_EVENT:
        case EVENT_FORM_MODE.CONFIRM:
            return (
                <InspectionEventFormCreateEventTrafiDialog wrappedVehicle={wrappedVehicle}>
                    {() => <EventForm />}
                </InspectionEventFormCreateEventTrafiDialog>
            )
        }
    }

    return <EventForm />
}

export default flowRight(
    withTranslationCustom('events'),
    graphql(getInspectionEventFormData, {
        options: ({ vehicleId }) => ({
            variables: {
                vehicleId,
            },
            fetchPolicy: fetchPolicy.NETWORK_ONLY,
        }),
    }),
)(InspectionEventForm)
